module.exports = __webpack_public_path__ + "static/media/client1.12569838.png";